import { render, staticRenderFns } from "./marketSingleValume.vue?vue&type=template&id=29e6c02e&scoped=true&"
import script from "./marketSingleValume.vue?vue&type=script&lang=js&"
export * from "./marketSingleValume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e6c02e",
  null
  
)

export default component.exports